import type { SeoSiteSettings } from '@/modules/seo/siteSettings';

export const seoDefaults: SeoSiteSettings = {
  site_title: 'The Forbidden Studio',
  favicon_path: 'https://pub-a5b75dbdde7a4e1bb2125de6269481f8.r2.dev/favicon.jpeg',
  seo_default_title: 'The Forbidden Studio - Galerías Exclusivas de Fotografía Premium',
  seo_default_description: 'Explora galerías exclusivas TFS con una estética Luxury Boutique, sensualidad editorial y compra simple.',
  seo_default_social_image_path: '',
  organization_name: 'The Forbidden Studio',
  organization_logo_path: '',
};
